import React from 'react';

export const MCSAJourney = () => {
    return (
        <iframe
            title="Journey"
            src="/mcsa_htmls__TBD/mindshield_journey/ms-journey.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
